import { BusinessUnitResolverService } from '@fi-app/business-unit/business-unit-resolver.service';

export const FiBusinessUnitStateResolveDataFields = [
    'dataFieldGroup',
    BusinessUnitResolverService,
    FiBusinessUnitStateResolveFiBusinessUnitStateResolveDataFields_resolveFunc,
];

export function FiBusinessUnitStateResolveFiBusinessUnitStateResolveDataFields_resolveFunc(
    dataFieldGroup,
    businessUnitResolverService: BusinessUnitResolverService,
) {
    return businessUnitResolverService.ResolveBusinessUnitDataFields(dataFieldGroup);
}
